import { Routes, Route } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { lazy, useEffect, useRef, useState } from 'react';
import PrivateRoute from './PrivateRoute';
import { useDispatch, useSelector } from 'react-redux';
import { checkIfAdmin } from '../utility/auth';
import { downloadExcelFromLink } from '../utility/excel';
import {
  resetDiDownloadFileResponse,
  resetDiReportError,
} from '../redux/diSlice';
import * as _ from 'lodash';
import {
  resetForecastDownloadFileResponse,
  resetForecastReportError,
} from '../redux/forecastSlice';
import {
  resetCartonSummaryDownloadFileResponse,
  resetCartonSummaryReportError,
} from '../redux/cartonSummarySlice';

import Chatbot from '../components/Chatbot/Chatbot';
const Home = lazy(() => import('../pages/Home'));
const UserManagement = lazy(() => import('../pages/UserManagement'));
const PartsBackOrder = lazy(() => import('../pages/partsBackOrder'));
const AccessDenied = lazy(() => import('../pages/AccessDenied'));
const ManualFileUpload = lazy(() => import('../pages/ManualFileUpload'));
const CustomiseHomeScreen = lazy(() => import('../pages/CustomiseHomeScreen'));
const Login = lazy(() => import('../pages/LoginPage'));

function AppRoutes() {
  const [isAdmin, setAdmin] = useState(false);
  const userInfo = useSelector((state) => state.user.userInfo);

  const diIntervalRef = useRef(null);
  const [diRequestId, setDiRequestId] = useState('');
  const diDownloadFileResponse = useSelector(
    (state) => state.di.diDownloadFileResponse
  );

  const forecastIntervalRef = useRef(null);
  const [forecastRequestId, setForecastRequestId] = useState('');
  const forecastDownloadFileResponse = useSelector(
    (state) => state.forecast.forecastDownloadFileResponse
  );

  const cartonSummaryIntervalRef = useRef(null);
  const [cartonSummaryRequestId, setCartonSummaryRequestId] = useState('');
  const cartonSummaryDownloadFileResponse = useSelector(
    (state) => state.cartonSummary.cartonSummaryDownloadFileResponse
  );

  const dispatch = useDispatch();

  useEffect(() => {
    const isAdmin = checkIfAdmin(userInfo);
    setAdmin(isAdmin);
  }, [userInfo]);

  useEffect(() => {
    if (diDownloadFileResponse) {
      const isS3URLPresent = _.has(diDownloadFileResponse, 's3_url');
      if (isS3URLPresent) {
        clearInterval(diIntervalRef.current);
        downloadExcelFromLink(diDownloadFileResponse.s3_url);
        dispatch(resetDiReportError());
        dispatch(resetDiDownloadFileResponse());
      }
    }
  }, [diDownloadFileResponse]);

  useEffect(() => {
    if (forecastDownloadFileResponse) {
      const isS3URLPresent = _.has(forecastDownloadFileResponse, 's3_url');
      if (isS3URLPresent) {
        clearInterval(forecastIntervalRef.current);
        downloadExcelFromLink(forecastDownloadFileResponse.s3_url);
        dispatch(resetForecastReportError());
        dispatch(resetForecastDownloadFileResponse());
      }
    }
  }, [forecastDownloadFileResponse]);

  useEffect(() => {
    if (cartonSummaryDownloadFileResponse) {
      const isS3URLPresent = _.has(cartonSummaryDownloadFileResponse, 's3_url');
      if (isS3URLPresent) {
        clearInterval(cartonSummaryIntervalRef.current);
        downloadExcelFromLink(cartonSummaryDownloadFileResponse.s3_url);
        dispatch(resetCartonSummaryReportError());
        dispatch(resetCartonSummaryDownloadFileResponse());
      }
    }
  }, [cartonSummaryDownloadFileResponse]);

  return (
    <Routes>
      <Route exact path='/login' element={<Login />} />
      <Route exact path='/' element={<Navigate to='/home' />} />
      <Route
        exact
        path='/parts-back-order'
        element={
          <PrivateRoute>
            <PartsBackOrder
              diRequestId={diRequestId}
              setDiRequestId={setDiRequestId}
              diIntervalRef={diIntervalRef}
              forecastRequestId={forecastRequestId}
              setForecastRequestId={setForecastRequestId}
              forecastIntervalRef={forecastIntervalRef}
              cartonSummaryRequestId={cartonSummaryRequestId}
              setCartonSummaryRequestId={setCartonSummaryRequestId}
              cartonSummaryIntervalRef={cartonSummaryIntervalRef}
            />
            <Chatbot className='AppChatBot'></Chatbot>
          </PrivateRoute>
        }
      />
      <Route
        exact
        path='/home'
        element={
          <PrivateRoute>
            <Home />
            <Chatbot className='AppChatBot'></Chatbot>
          </PrivateRoute>
        }
      />
      <Route
        exact
        path='/user-management'
        element={
          <PrivateRoute deny={!isAdmin}>
            <UserManagement />
          </PrivateRoute>
        }
      />
      <Route
        exact
        path='/manual-file-upload'
        element={
          <PrivateRoute>
            <ManualFileUpload />
          </PrivateRoute>
        }
      />

      <Route
        exact
        path='/customize-home-screen'
        element={
          <PrivateRoute>
            <CustomiseHomeScreen />
          </PrivateRoute>
        }
      />

      <Route exact path='/access-denied' element={<AccessDenied />} />

      <Route path='*' element={<h2>Page Not Found</h2>} />
    </Routes>
  );
}

export default AppRoutes;
